import React from 'react';

export default class FacultyStaffLearnerRegistration extends React.Component {
  render() {
    return null;
  }
}
